/**
 * Product details column on desktop (when "sticky" is on): it scrolls with the page until its end is in view,
 * then stays there while the images keep scrolling, with the Summary at the top and its title, price and
 * buttons scrolled away.
 *
 * The floating add-to-cart card slides in as soon as the add-to-cart button is out of sight.
 */
(() => {
  const details = document.querySelector('.product-details.sticky-content--desktop');
  if (!details) return;

  const desktop = window.matchMedia('(min-width: 750px)');
  const card = document.querySelector('.sticky-add-to-cart__bar');
  // Price and add-to-cart count as hidden once the add-to-cart button is under the header
  const buyButtons = details.querySelector('.buy-buttons-block .add-to-cart-button') || details.querySelector('.buy-buttons-block');
  const cardHost = card?.closest('sticky-add-to-cart');
  const GAP = 24;
  let frame = 0;
  let lastTop = null;
  let hasRoom = null;

  // product-information.liquid shows the card from data-card-show (set below) instead of Horizon's own trigger
  cardHost?.setAttribute('data-wait-for-room', '');

  const update = () => {
    frame = 0;
    if (!desktop.matches) {
      details.style.removeProperty('--details-sticky-top');
      lastTop = null;
      return;
    }

    const header = document.querySelector('#header-component');
    const headerHeight = header ? header.offsetHeight : 0;

    const accordion = details.querySelector('.accordion');
    // Title, price and buttons always scroll away (the floating card takes over) and the column stops with the
    // whole Summary card in view right under the header. A very long column shows its last rows when the images end.
    const accordionOffset = accordion ? accordion.getBoundingClientRect().top - details.getBoundingClientRect().top : 0;
    let top = headerHeight + 16 - accordionOffset;
    top = Math.round(top);
    if (top !== lastTop) {
      lastTop = top;
      details.style.setProperty('--details-sticky-top', `${top}px`);
    }

    // The card shows as soon as the add-to-cart button is out of sight (under the header or above the screen)
    if (cardHost && buyButtons) {
      const show = buyButtons.getBoundingClientRect().bottom < headerHeight;
      if (show !== hasRoom) {
        hasRoom = show;
        cardHost.toggleAttribute('data-card-show', show);
      }
    }
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  // The column changes height when an accordion row opens or closes
  new ResizeObserver(schedule).observe(details);
  if (card) {
    new ResizeObserver(schedule).observe(card);
    new MutationObserver(schedule).observe(card, { attributes: true, attributeFilter: ['data-stuck'] });
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  desktop.addEventListener('change', schedule);
  update();
})();
